// extracted by mini-css-extract-plugin
export default {"h1":"VendorSaleList_h1__j-jtt","scrollCover":"VendorSaleList_scrollCover__B7cvA","liquid":"VendorSaleList_liquid__LYcbl","saleListCont":"VendorSaleList_saleListCont__531wD"};